export const homeImageWithTextConfig = {   
    highlight: "Testimonials", 
    variant: "highlighted" as const,
    highlightedHeadingMain: "What Our ",
    highlightedHeadingAccent: "Clients are Saying",  
    showSwiper: true,
    imageUrl: "/images/c7a7c54a11cedabd86d374c31ea3d325.jpg",
    altText: "Testimonial",
};
export const aboutUsImageWithTextConfig = {   
    highlight: "Who We Are",
    heading:  "Defy Medical’s goal is to treat the whole patient, not just one or two symptoms.",
    variant: "standard" as const, 
    sectionDescription: "Defy Medical is a concierge clinic that has specialized in Men’s Health for more than a decade. We know how important sexual intimacy is for quality of life, and we take issues like erectile dysfunction seriously.",
    showSwiper: false,
    imageUrl: "/images/about-us/998a75eafee45d540fc3e612aa6e4a58-about-who.jpg",
    altText: "About-Us-Who-We-Are",
};
